import type { IObjectiveRequirementsAndObjectives } from './ObjectiveRequirementsAndObjectives.interface';
import ObjectiveRequirementsAndObjectivesPurposeType from './ObjectiveRequirementsAndObjectivesPurposeType';
import ObjectiveRequirementsAndObjectivesPurposeDetails from './ObjectiveRequirementsAndObjectivesPurposeDetails';
import ObjectiveRequirementsAndObjectivesRefinanceAndDebtConsolidation from './ObjectiveRequirementsAndObjectivesRefinanceAndDebtConsolidation';
import { YesNoOption } from '../global/YesNoOption.enum';

export default class ObjectiveRequirementsAndObjectives
  implements IObjectiveRequirementsAndObjectives {
  purposeType: ObjectiveRequirementsAndObjectivesPurposeType;
  purposeDetails: ObjectiveRequirementsAndObjectivesPurposeDetails;
  applicantsUnderstandPurposes: YesNoOption;
  creditCardReducedOrCancelled: YesNoOption;
  creditCardReducedOrCancelledComments: string;
  applicantsUnderstandThatMayEndUpPayMoreInterest: YesNoOption;
  refinanceAndDebtConsolidation: ObjectiveRequirementsAndObjectivesRefinanceAndDebtConsolidation;

  static build = (data: IObjectiveRequirementsAndObjectives) =>
    new ObjectiveRequirementsAndObjectives(data);

  static blank = () => new ObjectiveRequirementsAndObjectives();

  /**
   * Constructor
   * @param {IObjectiveRequirementsAndObjectives} data
   */
  constructor(data?: IObjectiveRequirementsAndObjectives) {
    this.purposeType = new ObjectiveRequirementsAndObjectivesPurposeType(data?.purposeType);
    this.purposeDetails = new ObjectiveRequirementsAndObjectivesPurposeDetails(
      data?.purposeDetails
    );
    // TODO: data?.applicantsUndertandPurposes is legacy data structure
    this.applicantsUnderstandPurposes = YesNoOption.of(
      data?.applicantsUnderstandPurposes?.name ||
        data?.applicantsUndertandPurposes?.toString() ||
        data?.applicantsUnderstandPurposes?.toString()
    );
    this.creditCardReducedOrCancelled = YesNoOption.of(
      data?.creditCardReducedOrCancelled?.name || data?.creditCardReducedOrCancelled?.toString()
    );
    this.creditCardReducedOrCancelledComments =
      data?.creditCardReducedOrCancelledComments || '';
    this.applicantsUnderstandThatMayEndUpPayMoreInterest = YesNoOption.of(
      data?.applicantsUnderstandThatMayEndUpPayMoreInterest?.name ||
        data?.applicantsUnderstandThatMayEndUpPayMoreInterest?.toString()
    );
    this.refinanceAndDebtConsolidation = new ObjectiveRequirementsAndObjectivesRefinanceAndDebtConsolidation(
      data?.refinanceAndDebtConsolidation
    );
  }
}
